import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { u as useToggletipContext, a as useMergeRefs } from "../../../../chunks/useToggletip-C_JZsx5D.js";
import { c as clsx } from "../../../../chunks/clsx-DF9QTL9H.js";
import "../../../../foundations/icons/IconsDefault.js";
import { Text } from "../../../../foundations/typography/Text/Text.js";
import { ToggletipIcon } from "./ToggletipIcon.js";
import { s as styles } from "../../../../chunks/Toggletip.module-DtY52kab.js";
const ToggletipExplainer = forwardRef(function ToggletipExplainer2({ ariaLabel, showLabel, variant, className, ...props }, propRef) {
  const context = useToggletipContext();
  const ref = useMergeRefs([context.refs.setReference, propRef]);
  return /* @__PURE__ */ jsxs(
    "button",
    {
      ref,
      type: "button",
      className: clsx(
        styles.toggletipExplainer,
        showLabel ? styles.toggletipButton : styles.toggletipTrigger,
        className
      ),
      "aria-label": ariaLabel,
      ...context.getReferenceProps(props),
      children: [
        /* @__PURE__ */ jsx(ToggletipIcon, { isActive: context.open, variant }),
        showLabel && /* @__PURE__ */ jsx(Text, { component: "span", className: clsx(styles[`toggletip-${variant}-text`]), children: ariaLabel })
      ]
    }
  );
});
export {
  ToggletipExplainer
};
